import React from 'react'
import ButtonWithLoader from './ButtonWithLoader'
import { useDispatch } from 'react-redux'
import { REMOVE_SLIDE } from '../redux/manageSlidesReducer'
import { useParams } from 'react-router-dom'

const RemoveSlideModal = ({ onClose }: { onClose: () => void }) => {
  const dispatch = useDispatch()
  const { lessonPlanId } = useParams()

  const handleSubmit = () => {
    dispatch(REMOVE_SLIDE({ lessonPlanId: lessonPlanId as string }))
    onClose()
  }

  return (
    <div>
      <div className="h-20" />
      <div className="bg-white rounded-md p-4 max-w-[27rem] w-screen">
        <h2 className="text-24 font-semibold">Are you sure you want to remove this slide?</h2>
        <div className="flex justify-end mt-4">
          <div className="w-24 flex justify-end">
            <ButtonWithLoader label="Remove" onClick={handleSubmit} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RemoveSlideModal
